<section class="hero-section">
  <div class="container mx-lg-5">
    <div class="hero-content p-lg-5 p-3">
      <div class="display-5 fw-bold mb-4">Hire Top 3% of Pre-Vetted IT Experts fast </div>
      <p class="lead mb-4">Success starts with the right people at the right time. Scale your business with pre-vetted,
        high-performing IT professionals who don't just fill roles but drive impact.</p>
      <div class="btn-wrapper">
        <a href="contact" class="global_button   text-left col text-white white_button" aria-label="View Contact Page">
          <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png" alt="arrow_img" /></div>
          TALK TO OUR EXPERT
        </a>
      </div>
    </div>
  </div>
</section>


<!-- Hiring Models Section -->
<section class="bg-light py-5 ">
  <div class="container">
    <h2 class="text-center section-title">Hiring Models</h2>
    <div class="text-center h2 mb-3">The Right Talent, Delivered Your Way </div>
    <p class="text-center mb-4 hiringSec">Every business runs on different timelines, budgets, and delivery models, and
      that’s why we offer more than one way to staff. Whether you need to move fast, scale flexibly, or reduce long-term
      hiring
      risk, our customizable staffing models
      are designed to meet your unique operational needs. Get the right people, with the right expertise, through the
      right engagement format. </p>
    <div class="row g-0 justify-content-center" id="staffingModels">
      <div class="col-md-6 col-lg-4 col-xl-3 p-2">
        <div class="feature-card">
          <div class="circle-container">
            <div class="pie-wrapper progress-15"></div>
          </div>
          <div class="h5 fw-bold mb-2 hiringblocks">Contract Staffing</div>

          <div class="description  hiringSec">
            <div class="card__corner">
              <div class="card__corner-triangle"></div>
            </div>
            <div class="h5 fw-bold mb-1 hiringblocks">Contract Staffing</div>

            <div class="descContent">
              Rapid access to expert talent for short-term initiatives, seasonal demand, or skill gaps, agile and
              cost-effective.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 col-xl-3 p-2">
        <div class="feature-card text-center">
          <div class="circle-container">
            <div class="pie-wrapper progress-50"></div>
          </div>
          <div class="h5 fw-bold mb-2 hiringblocks">Contract-to-Hire</div>
          <div class="description hiringSec">
            <div class="card__corner">
              <div class="card__corner-triangle"></div>
            </div>
            <div class="h5 fw-bold mb-2 hiringblocks">Contract-to-Hire</div>

            <div class="descContent">Reduce hiring risk. Evaluate talent on the job before extending a full-time offer,
              transition plans included.
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-lg-4 col-xl-3  p-2">
        <div class="feature-card">
          <div class="circle-container ">
            <div class="pie-wrapper progress-75"></div>
          </div>
          <div class="h5 fw-bold mb-2 hiringblocks">Project-Based Teams</div>
          <div class="description hiringSec">
            <div class="card__corner">
              <div class="card__corner-triangle"></div>
            </div>
            <div class="h5 fw-bold mb-2 hiringblocks">Project-Based Teams</div>
            <div class="descContent"> Hit the ground running with complete, cross-functional teams to execute scoped
              deliverables-developers, architects, PMs, and more.
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 col-xl-3 p-2">
        <div class="feature-card">
          <div class="circle-container ">
            <div class="pie-wrapper progress-100"></div>
          </div>
          <div class="h5 fw-bold mb-2 hiringblocks">Direct Hire</div>

          <div class="description hiringSec">
            <div class="card__corner">
              <div class="card__corner-triangle"></div>
            </div>
            <div class="h5 fw-bold mb-2 hiringblocks">Direct Hire</div>

            <div class=""> Secure long-term talent for critical roles that require stability, expertise, and business
              alignment.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<style>
</style>
<section class="solutions-section py-3 py-lg-5 bg-white">
  <div class="container">
    <div class="row  g-0 align-items-strech">

      <div class="col-lg-4 d-flex px-3 px-lg-0">
        <img src="../../../assets/images/staffing/technology-It-staffing/embedded.jpeg" alt="Tall Image"
          class="w-100 h-100 object-fit-cover rounded-1" style="object-fit: cover;object-position: 65%;">
      </div>

      <div class="col-lg-8 d-flex flex-column justify-content-center px-3 px-lg-5">
        <div class=" h2 mb-4 pt-3 pt-lg-0 ">Embedded Global Teams</div>
        <p class="mb-3  ">Expand your workforce without borders. With our Embedded Global Teams, you gain access
          to top-tier talent worldwide, seamlessly integrated into your operations from day one.</p>
        <p class="mb-4  ">These aren't outsourced hires, they're dedicated professionals aligned with your
          workflow, time zone, and business goals.</p>
        <ul class="list-unstyled">
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Custom-built teams tailored to your business needs.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Timezone-aligned professionals for seamless collaboration.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Fully managed workforce solutions that reduce overhead and increase agility.
          </li>
        </ul>

      </div>
    </div>
  </div>
</section>
<!-- Consulting Section -->
<section class="consulting-section py-3 py-lg-5 bg-light">
  <div class="container">
    <div class="row align-items-stretch g-0 flex-lg-row flex-column-reverse">
      <div class="col-lg-8 d-flex flex-column justify-content-center ps-3 ps-lg-2 pe-3 pe-lg-5 ">
        <div class="h2 mb-4 pt-3 pt-lg-0">Consulting</div>
        <p class="mb-4 ">Get on-demand specialists who step in, solve complex problems, and deliver
          results, without hiring delays, overhead, or long-term commitments.</p>
        <p class="mb-4 ">Whether it's cloud transformation, AI implementation, cybersecurity, or IT strategy, our
          consultants integrate seamlessly into your team, bringing deep expertise and outcome-driven
          execution, structured under a clear Statement of Work (SOW).</p>

        <ul class="list-unstyled">
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Immediate access to top IT specialists, no long hiring cycles.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Defined scope, deliverables, and timelines, ensuring measurable results
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Flexible, scalable engagement, only pay for expertise when needed.
          </li>
        </ul>
      </div>
      <div class="col-lg-4  d-flex px-3 px-lg-0">

        <img src="../../../assets/images/staffing/technology-It-staffing/consultingImage.jpeg" alt="Consulting Services"
          class="w-100 h-100 object-fit-cover rounded-1" style="object-fit: cover;object-position: 75%;">

      </div>
    </div>
  </div>
</section>

<!-- Leadership Hiring Section -->
<section class="solutions-section bg-white py-3 py-lg-5">
  <div class="container">
    <div class="row g-0 align-items-stretch">
      <div class="col-lg-4 d-flex px-3 px-lg-0">
        <img src="../../../assets/images/staffing/technology-It-staffing/leadership_hiring.jpeg" alt="Leadership Hiring"
          class="w-100 h-100 object-fit-cover rounded-1" style="object-fit: cover;object-position: 30%;">


      </div>
      <div class="col-lg-8  d-flex flex-column justify-content-center  px-3 px-lg-5 ">
        <div class="h2 mb-4 pt-3 pt-lg-0  ">Leadership Hiring</div>
        <p class="mb-4 ">Your company's success depends
          on the leaders steering it forward. Our executive search ensures you get high-impact decision-makers who align
          with your business strategy, culture, and long-term goals, without the uncertainty of a drawn-out hiring
          process.</p>
        <p class="mb-4 ">We identify, vet, and secure top executive talent who can drive growth, navigate change,
          and make an immediate impact. Whether you need a proven industry leader or a rising star, we deliver precisely
          matched executives who don't just fill a position, they elevate your business.</p>

        <ul class="list-unstyled">
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            C-Level & VP searches tailored to your industry.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Confidential executive placement with targeted outreach.
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Global talent mapping & leadership succession planning.
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!-- Creative Teams Section -->
<section class="solutions-section py-3 py-lg-5 bg-light">
  <div class="container">
    <div class="row align-items-stretch g-0 flex-lg-row flex-column-reverse" style="min-height: 100%;">
      <div class="col-lg-8 d-flex flex-column justify-content-center ps-3 ps-lg-2 pe-3 pe-lg-5  ">
        <div class="h2 mb-4 pt-3 pt-lg-0 ">Creative Teams</div>
        <p class="mb-4 ">Your marketing doesn't need more ideas, it needs execution that delivers measurable
          growth. Our creative team works inside your business, giving you the right mix of experts to build branding,
          content, and campaigns that don't just grab attention but drive real revenue.</p>
        <h3 class="h4 mb-4">Our Creative Experts For Your Success</h3>
        <ul class="list-unstyled">
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Content writers
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Brand Experts
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Marketing Specialists
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Graphics & UX Designers
          </li>
        </ul>
      </div>
      <div class="col-lg-4 d-flex px-3 px-lg-0">

        <img src="../../../assets/images/staffing/technology-It-staffing/creative_teams.png" alt="Creative Teams"
          class="w-100 h-100 object-fit-cover rounded-1" style="object-fit: cover;object-position: 65%;">

      </div>
    </div>
  </div>
</section>
<!-- What We Do Section -->
<section class=" py-3 py-lg-5 bg-white " id="chooseUs">
  <div class="container " >
    <h2 class="text-center section-title">Why Choose Us</h2>
    <p class="text-center mb-2 hiringSec">We are a trusted IT staffing partner for forward-thinking teams.Our deep
      expertise, fast delivery, and precision matching help you build high-performing teams without compromise. </p>

    <div class="row g-0 justify-content-center">
      <div class=" col-sm-12 col-md-6 col-lg-4 col-xl-4 p-3">

        <div class="feature-card">
          <div class="d-flex align-items-center gap-3 mb-3">
            <img src="../../../assets/images/staffing/technology-It-staffing/speeddelivery.png" alt="Flexible Hiring"
              style="max-width: 60px; max-height: 60px;">
            <div class="mb-0 h5 fw-bold">Speed to Delivery</div>
          </div>
          <p>Receive qualified, pre-vetted candidate profiles within 24 – 48 hours for most roles.</p>
        </div>
      </div>
      <div class=" col-sm-12 col-md-6 col-lg-4 col-xl-4 p-3">
        <div class="feature-card">
          <div class="d-flex align-items-center gap-3 mb-2">

            <div class="">
              <i class="bi bi-globe fs-1 text-primary mb-3 " style="max-width: 60px;max-height: 60px;"></i>
            </div>

            <div class="mb-0 h5 fw-bold">Rigorously Vetted Talent</div>
          </div>

          <p>Candidates undergo technical assessments, soft skill evaluation, and compliance checks before submission.
          </p>
        </div>
      </div>
      <div class=" col-sm-12 col-md-6 col-lg-4 col-xl-4 p-3">
        <div class="feature-card">
          <div class="d-flex align-items-center gap-3 mb-2">
            <img src="../../../assets/images/staffing/technology-It-staffing/network.png" alt="Flexible Hiring"
              class="img-fluid mb-3" style="max-width: 60px;max-height: 60px;">

            <div class="mb-0 h5 fw-bold">Industry-Aware Recruiting</div>
          </div>

          <p>We understand the language, tools, and priorities of IT, and we align our sourcing accordingly.</p>
        </div>
      </div>
      <div class=" col-sm-12 col-md-6 col-lg-4 col-xl-4 p-3">
        <div class="feature-card">
          <div class="d-flex align-items-center gap-3 mb-2">

            <img src="../../../assets/images/staffing/technology-It-staffing/usoperations.png" alt="Flexible Hiring"
              class="img-fluid mb-3" style="max-width: 60px;max-height: 60px;">
            <div class="mb-0 h5 fw-bold">U.S - Led Operations</div>
          </div>

          <p>We are headquartered in the U.S. with global sourcing support for scale and agility.</p>
        </div>
      </div>
      <div class=" col-sm-12 col-md-6 col-lg-4 col-xl-4 p-3">
        <div class="feature-card">
          <div class="d-flex align-items-center gap-3 mb-2">
            <img src="../../../assets/images/staffing/technology-It-staffing/suppliercert.png" alt="Flexible Hiring"
              class="img-fluid mb-3" style="max-width: 60px;max-height: 60px;">

            <div class="mb-0 h5 fw-bold">Certified Supplier</div>
          </div>

          <p>We are a Minority Business Enterprise (MBE), Women-Owned Business Enterprise (WBE), and Women-Owned Small
            Business (WOSB).</p>
        </div>
      </div>
    </div>

    <div class="btn-wrapper pt-5 pb-0 text-center">

      <a href="tech-hiring" class="global_button  " role="button" aria-label="View Contact Page" tabindex="0">
        <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="arrow black" /></div>
        View Our Recruiter Expertise
      </a>

    </div>
  </div>
</section>

<section class="pb-5 pt-5 bg-light">
  <div class="gradation-process-area ">
    <div class="container-fluid">
      <div class="row ">
        <div class="col-lg-12">
          <div class="text-center section-space--mb_60">

            <div class="gradation-title-wrap " role="contentinfo">
              <div class="text-center h2 mb-3"> Your Path to Confident Tech Hiring </div>
              <p class="text-center mb-5 hiringSec px-5">Our process is designed to keep you informed, involved, and in
                control, without having to manage the details.
              </p>
            </div>
            <div class="gradation-sub-heading">
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div>
          <div class="process-container">
            <div class="step">
              <div class="arrow idea">
                <i class="fas fa-user-check"></i>
              </div>
              <h3 class="">Background Checks</h3>
            </div>
            <div class="step">
              <div class="arrow idea">
                <i class="fas fa-clipboard-list"></i>
              </div>
              <h3>Role-Based Assessments</h3>
            </div>
            <div class="step">
              <div class="arrow idea">
                <i class="fas fa-handshake"></i>
              </div>
              <h3>Expectation Alignment</h3>
            </div>
            <div class="step">
              <div class="arrow idea">
                <i class="fas fa-file-signature"></i>
              </div>
              <h3 class="">Offer & Negotiation</h3>
            </div>
            <div class="step">
              <div class="arrow idea">
                <i class="fas fa-sign-in-alt"></i>
              </div>
              <h3>Seamless Onboarding</h3>
            </div>
            <div class="step">
              <div class="arrow idea">
                <i class="fas fa-comments"></i>
              </div>
              <h3>Transparent Communication</h3>
            </div>
          </div>
          <p class="text-center hiringSec px-5 py-4">
            While we follow a 10-step internal methodology, we highlight the six stages that matter most to you. These
            focus on clear communication and structured onboarding that make hiring straightforward, reliable, and
            effective. </p>
          <div class="btn-wrapper  pb-0 text-center">

            <a href="staffing-process" class="global_button  " role="button" aria-label="View Contact Page"
              tabindex="0">
              <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="arrow black" /></div>
              Explore Our Hiring Framework
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="py-3 py-lg-5 bg-white" id="industrieServe">
  <div class="container">
    <h2 class="text-center section-title">Industries</h2>
    <div class="text-center h2 mb-4">The Businesses We Support</div>

    <div class="row g-0 justify-content-center ">
      <div class="col-md-4 p-4">
        <div class="feature-card">
          <!-- <i class="bi bi-people-fill fs-1 text-primary mb-3"></i> -->
          <div class=" text-center pb-2">
            <img src="../../../assets/images/staffing/technology-It-staffing/cards.png" alt="Flexible Hiring"
              class="img-fluid mb-3" style="max-width: 73px;">
            <div class="text-dark fw-bold mt-2 h5">
              Fintech & Payments</div>
            <p class="text-center  hiringSec py-2">
              Secure, scalable IT solutions for financial services.</p>
          </div>

        </div>
      </div>
      <div class="col-md-4 p-4">
        <div class="feature-card">
          <div class=" text-center pb-2">
            <img src="../../../assets/images/staffing/technology-It-staffing/healthcare.png" alt="Global Reach"
              class="img-fluid mb-3" style="max-width: 73px;">
            <div class="text-dark fw-bold mt-2 h5">
              Healthcare & MedTech</div>
            <p class="text-center  hiringSec  py-2">
              Compliance-driven tech talent for digital health innovation.</p>

          </div>

        </div>
      </div>
      <div class="col-md-4 p-4">
        <div class="feature-card">
          <div class=" text-center pb-2">
            <img src="../../../assets/images/staffing/technology-It-staffing/ecommerce.png" alt="Flexible Hiring"
              class="img-fluid mb-3" style="max-width: 73px;">
            <div class="text-dark fw-bold mt-2 h5">
              eCommerce & Retail</div>
            <p class="text-center hiringSec py-2">
              Scalable platforms, payment solutions, and customer experience enhancement.</p>

          </div>

        </div>
      </div>
      <div class="col-md-4 p-4">
        <div class="feature-card">
          <div class=" text-center pb-2">
            <img src="../../../assets/images/staffing/technology-It-staffing/cyber_ai.png" alt="Flexible Hiring"
              class="img-fluid mb-3" style="max-width: 73px;">
            <div class="text-dark fw-bold mt-2 h5">
              Cybersecurity & AI</div>
            <p class="text-center hiringSec  py-2">
              Protecting data with industry-leading AI and cybersecurity expertise.</p>

          </div>

        </div>
      </div>
      <div class="col-md-4 p-4">
        <div class="feature-card">
          <div class=" text-center pb-2">
            <img src="../../../assets/images/staffing/technology-It-staffing/saasEnterprise.png" alt="Flexible Hiring"
              class="img-fluid mb-3" style="max-width: 73px;">
            <div class="text-dark fw-bold mt-2 h5">
              SaaS & Enterprise Tech </div>
            <p class="text-center hiringSec py-2">
              Product development, DevOps, and cloud infrastructure support.</p>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div class="corporateRolesbg-color">
  <!-- <div class="roles-section" id="coporateRoles">
  <h2 class="subtitle">Roles We Fill</h2>
  <h2 class="title">Specialized Talent Across Technical and Corporate Functions</h2>
  <p class="hiringSec mb-3">
    We connect you with professionals who understand your tech stack, delivery goals, and cultural environment, 
    because successful hiring is about more than skills. It's about fit, readiness, and long-term alignment.
  </p>

  <div class="tabs">
    <button class="tab" [class.active]="activeTab === 'technical'" (click)="activeTab = 'technical'">Technical
      Roles</button>
    <button class="tab" [class.active]="activeTab === 'corporate'" (click)="activeTab = 'corporate'">HR & Corporate
      Roles</button>
  </div>

  <div class="tab-content" *ngIf="activeTab === 'technical'">
    <div class="roles-grid">
      <div class="role-item" *ngFor="let role of technicalRoles; let i = index">
        <span class="custom-arrow"></span>
        <div [ngStyle]="{
    'padding-left': i === 0 || i === 3 ? '0.5rem' : (i === 6 ? '0.2rem' : '')
  }">
          <strong>{{ role.title }}</strong>
          <p class="hiringSec">{{ role.description }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="tab-content" *ngIf="activeTab === 'corporate'">
    <div class="roles-grid">
      <div class="role-item" *ngFor="let role of corporateRoles let i = index">
        <span class="custom-arrow"></span>
        <div [ngStyle]="{
    'padding-left': i === 0 || i === 3 ? '0.5rem' :''
  }">
          <p>{{ role }}</p>
        </div>
      </div>
    </div>
  </div>
</div> -->
  <div class="roles-section" id="coporateRoles">
    <h2 class="subtitle">Roles We Fill</h2>
    <h2 class="title">Specialized Talent Across Technical and Corporate Functions</h2>
    <p class="description">
      We connect you with professionals who understand your tech stack, delivery goals, and cultural environment—
      because successful hiring is about more than skills. It's about fit, readiness, and long-term alignment.
    </p>

    <div class="tabs">
      <button class="tab" [class.active]="activeTab === 'technical'" (click)="activeTab = 'technical'">Technical
        Roles</button>
      <button class="tab" [class.active]="activeTab === 'corporate'" (click)="activeTab = 'corporate'">HR & Corporate
        Roles</button>
    </div>

    <div class="tab-content" *ngIf="activeTab === 'technical'">
      <div class="row g-0">
        <div class="col-md-6  p-0 ">
          <div class="role-card">
            <div class="overlay-content ">
              <ul>
                <li><b>Developers :</b><br>Full-Stack, Backend, and Frontend (React, Angular, Node.js, Python, .NET,
                  Java)</li>
                <li><b>Mobile Engineers :</b><br>OS, Android, Flutter, React Native</li>
                <li><b>Cloud & Infrastructure :</b><br> AWS, Azure, GCP Architects, DevOps Engineers, SREs </li>
                <li><b>Data & AI :</b><br> Data Engineers, Data Scientists, BI Developers, AI/ML Specialists, NLP
                  Experts </li>

              </ul>
            </div>

          </div>
        </div>
        <div class="col-md-6  p-0  border-0">
          <div class="role-card">
            <div class="overlay-content ">
              <ul>
                <li><b>Cybersecurity :</b><br>Analysts, Security Engineers, and Architects' </li>
                <li><b>ERP Specialists :</b><br>SAP, Oracle, Microsoft Dynamics </li>
                <li><b>QA & Testing :</b><br> Automation Testers, Manual Testers, Performance Engineers </li>
                <li><b>Project & Product Management :</b><br> Project Managers, Scrum Masters, Product Owners </li>
                <li><b>Support & Systems :</b><br> System Administrators, Network Engineers, Helpdesk, IT Support </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="tab-content" *ngIf="activeTab === 'corporate'">
      <div class="row g-0">
        <div class="col-md-6 p-0 ">
          <div class="role-card">
            <div class="overlay-content ">
              <ul>
                <li>Talent Acquisition & Technical Recruiters</li>
                <li>HR Generalists, HR Business Partners (HRBPs), DEI Specialists</li>

              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-6  p-0  border-0">
          <div class="role-card">
            <div class="overlay-content ">
              <ul>
                <li>Payroll & Benefits Administrators</li>
                <li>L&D Consultants, Change Managers, Compliance Analysts </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
<section class="solutions-section py-3 py-lg-5 bg-white">
  <div class="container">

    <div class="row align-items-stretch g-0  flex-lg-row flex-column-reverse " style="min-height: 100%;">

      <div class="col-lg-8 d-flex flex-column justify-content-center px-3 px-lg-5  ">  
          <h2 class="mt-1 mb-2 text-left" style="text-align: left;color:#4169E1;">Success Stories: See Our Impact </h2>

        <div class="h2 mb-4 hiringblocks ">How We Helped a SaaS Startup Scale from 5 to 50 Developers </div>
        <p class="mb-4 "> A fast-growing SaaS company needed immediate tech expansion but couldn’t afford long
          recruitment cycles. Within two weeks, we placed a team of 12 engineers, reducing hiring time by 75% and
          accelerating product launch by six months. </p>
        <ul class="list-unstyled">
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            <strong>Tech stack expertise:</strong> Python, React, AWS
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Full integration with in-house teams
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            Ongoing hiring support for continued growth
          </li>
          <li class="mb-3">
            <i class="bi bi-check-circle-fill text-primary me-2"></i>
            <strong>Results: </strong>40% faster product development, 98% retention rate of hired engineers.
          </li>
        </ul>
      </div>
      <div class="col-lg-4 d-flex px-3 px-lg-0">

        <img src="../../../assets/images/staffing/technology-It-staffing/successstories.jpeg" alt="Creative Teams"
          class="w-100 h-100 object-fit-cover rounded-1" style="object-fit: cover;">

      </div>
    </div>
  </div>
</section>

<section class="py-5 bg-light">
  <div class="container">
    <div class="text-center h2 mb-5 fw-bold">Frequently Asked Questions</div>

    <div class="accordion" id="faqAccordion">

      <div class="row justify-content-center g-0">

        <div class="col-12 col-lg-9">
          <!-- Item 1 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingOne">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                What types of roles does Maganti IT staff?
              </button>
            </h2>
            <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                We specialize in a wide range of IT and corporate positions, including software developers, cloud
                engineers, DevOps specialists, data scientists, project managers, ERP consultants, QA engineers, and
                cybersecurity experts. We also support HR and operational roles such as recruiters, HRBPs, payroll
                specialists, and organizational change consultants.
              </div>
            </div>
          </div>

          <!-- Item 2 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingTwo">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                What industries do you serve?
              </button>
            </h2>
            <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                We serve clients in manufacturing, healthcare, finance, government, public education, and
                retail/eCommerce. Our consultants are familiar with industry-specific regulations like HIPAA, NIST, and
                Section 508.
              </div>
            </div>
          </div>

          <!-- Item 3 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingThree">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                Can you provide remote or hybrid staffing support?
              </button>
            </h2>
            <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                Yes. We support fully remote, hybrid, and on-site staffing models with a geographically distributed
                talent pool.
              </div>
            </div>
          </div>

          <!-- Item 4 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingFour">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                What makes Maganti IT different from other staffing firms?
              </button>
            </h2>
            <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                Speed, quality, breadth of services, diversity certifications (MBE, WBE, WOSB), and our high retention
                and placement success rates.
              </div>
            </div>
          </div>

          <!-- Item 5 -->
          <div class="accordion-item mb-3 shadow-sm border-0 rounded">
            <h2 class="accordion-header" id="headingFive">
              <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                Do you offer contract-to-hire and direct placement options?
              </button>
            </h2>
            <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div class="accordion-body">
                Yes, including Contract, Contract-to-Hire, and Direct Hire. Many clients use contract-to-hire to
                validate long-term fit.
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>
<section class="py-5 bg-white">
  <div class="container text-center">
    <h2 class="fw-bold mb-3">Build High-Performing Teams Without the Hiring Headaches. Let’s Talk.</h2>
    <p class="lead mb-4">
      Top tech talent moves fast, don’t get left behind. Whether you need a single developer, a high-performing team, or
      strategic leadership hires, we’re here to deliver the expertise you need, seamlessly and quickly.
    </p>
    <p class="fw-semibold fs-5 mb-4">Ready to hire the best? Let’s talk.</p>
    <div class=" pt-lg-3 pt-2 ">

      <a href="contact" class="global_button  text-left" role="button" aria-label="View Contact Page" tabindex="0">
        <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="arrow white" /></div>
        Find Top IT Talent Now
      </a>
    </div>
  </div>
</section>